import { useRef } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { usePageTitle } from '../hooks/usePageTitle'
import { useStrokesGainedOverview } from '../hooks/useStrokesGained'
import { BookGate, ClubPage, Container, Eyebrow, StrokesGainedOverviewView } from '../components/golf'

export function YourGameScreen() {
  usePageTitle('Your Game')
  const { isAuthenticated, user } = useAuth()
  const { overview, isLoading, error, membershipRequired, refresh } = useStrokesGainedOverview(isAuthenticated)
  const ledgerStatusRef = useRef<HTMLParagraphElement>(null)
  const name = user?.display_name?.trim() || user?.email?.split('@')[0] || 'you'
  return (
    <ClubPage chrome="clubhouse">
      <header className="border-b-[3px] border-double border-brass py-12 sm:py-15">
        <Container>
          <Eyebrow>The Clubhouse · Your Game</Eyebrow>
          <h1 className="mt-3 font-display text-[clamp(2.5rem,6vw,4.25rem)] font-medium leading-[0.95] text-pine">A private ledger<br />of every stroke.</h1>
          <p className="mt-4 max-w-[60ch] text-[15px] text-ink-soft">Your observations stay private and out of the Register and every shared round. Positive is better than the named baseline; negative is worse.</p>
          {isAuthenticated && <p className="mt-4 text-[12px] font-semibold text-fairway">Visible only to {name}</p>}
        </Container>
      </header>
      <BookGate isAuthenticated={isAuthenticated} membershipRequired={membershipRequired} error={null} emptyHeadingLevel={2}>
        <Container className={isLoading ? 'py-12' : undefined}>
          <p
            ref={ledgerStatusRef}
            role="status"
            aria-live="polite"
            aria-atomic="true"
            tabIndex={-1}
            className={isLoading ? 'text-[13.5px] text-ink-soft' : 'sr-only'}
          >
            {isLoading ? 'Reading your private ledger…' : !error && overview ? 'Your private ledger is ready.' : ''}
          </p>
        </Container>
        {!isLoading && error && (
          <Container className="py-12">
            <div role="alert" className="border-l-2 border-flag-deep pl-4 text-[13.5px] text-flag-deep">
              <p>{error}</p>
              <button
                type="button"
                onClick={() => {
                  ledgerStatusRef.current?.focus()
                  void refresh()
                }}
                className="mt-3 rounded-club-sm border border-fairway px-3 py-2 font-semibold text-fairway"
              >
                Try again
              </button>
            </div>
          </Container>
        )}
        {!isLoading && !error && overview && <StrokesGainedOverviewView overview={overview} />}
      </BookGate>
    </ClubPage>
  )
}
